// URL publica do Worker de redirect (apps/redirect, rota /r/<code>).
const DEFAULT_REDIRECT_BASE_URL = "https://r.lucralink.com.br";

export function redirectBaseUrl(): string {
  const configured = import.meta.env.VITE_REDIRECT_BASE_URL as string | undefined;
  return (configured?.trim() || DEFAULT_REDIRECT_BASE_URL).replace(/\/+$/, "");
}

export function shortLinkUrl(shortCode: string): string {
  return `${redirectBaseUrl()}/r/${shortCode}`;
}

/** So http(s) vira href: bloqueia javascript:/data: vindos do banco. */
export function safeHref(url: string | null | undefined): string | null {
  return url && /^https?:\/\//i.test(url) ? url : null;
}
